module.exports = __webpack_public_path__ + "static/media/edit-pencil-black.c93dd636.svg";